

type JudgeType = string | number | boolean | [] | object | undefined | null

export const isEmpty = (value: JudgeType) => {
  if (value === undefined || value === null || value === '') {
    return true
  }
  if (Array.isArray(value) && value.length === 0) {
    return true
  }
  return typeof value === 'object' && Object.keys(value).length === 0
}